import React, {Component} from 'react';
import axios from 'axios';
import classNames from 'classnames';
import settings from './../../config/settings.json';

import { getAllUrlParams } from './../../helper/util.js';

export default class AdDeliveryConfig extends Component {
  constructor(props) {
    super(props);
    this.state = { budget: this.props.budget, formHasErrors: false }

    this.budgetChanged = this.budgetChanged.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  budgetChanged(event) {
    event.target.value = event.target.value.replace(',', '.');

    this.setState({budget: event.target.value});

    if(isNaN(event.target.value)) {
      this.setState({ formHasErrors: true });
    } else {
      this.setState({ formHasErrors: false});
    }
  }
  handleSubmit(event) {
    var apikey = getAllUrlParams().apikey;
    var url = settings.relevanz.apiBase + '/capping?apikey=' + apikey + '&budget=' + this.state.budget;

    axios.post(url)
      .then((response) => {
        if(response.data === 'OK') {
          alert('Budget erfolgreich geändert');
        } else {
          alert('error');
        }
      }).catch((error) => {
        if(error.response.data.message === 'testcustomer') {
          alert('Während der Testphase ist das Ändern des Budgets nicht möglich. Du möchtest jetzt direkt mehr Gas auf deinen Shop? Wechsel jetzt in einen unserer Tarife!')
        } else {
          alert('Beim ändern des Budgets ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut oder wenden sie sich an unseren Support.');
        }
      });

    event.preventDefault();
  }
  render() {
    var formClass = classNames({
      'form-group': true,
      'form-md-line-input': true,
      'has-error': this.state.formHasErrors
    });

    return(
      <div className="portlet light bordered">
        <div className="portlet-title">
          <div className="caption font-green-haze">
            <i className="icon-settings font-green-haze">
            </i>
            <span className="caption-subject bold uppercase">Werbeeinstellungen</span>
          </div>
        </div>
        <div className="portlet-body form">
          <form
            role="form"
            id="budgetForm"
            className="form-horizontal"
            onSubmit={this.handleSubmit}>
            <div
              className="form-body"
              style={{ paddingTop: '0px' }}>
              <div className={formClass}>
                <label
                  className="col-md-2 control-label"
                  htmlFor="form_control_1">Tagesbudget</label>
                <div className="col-md-10">
                  <div className="input-group">
                    <span className="input-group-addon">€</span>
                    <input
                      type="text"
                      className="form-control"
                      name="number"
                      aria-invalid="false"
                      aria-describedby="number-error"
                      onChange={this.budgetChanged}
                      value={this.state.budget} >
                    </input>
                    { this.state.formHasErrors && <span id="name-error" className="help-block help-block-error">Bitte geben Sie einen gültigen Betrag ein.</span> }
                    <div className="form-control-focus">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="form-actions"
              style={{ paddingTop: '0px' }}>
              <div className="row">
                <div className="col-md-10">
                  <input
                    type="submit"
                    className="btn blue"
                    value="Speichern" />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/config/AdDeliveryConfig.js